import {
    $, addAction, LAYOUTEND, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const $navItems = $('.footer-site-info__policies .menu-item');
    addAction(LAYOUTEND, () => {
        $navItems.removeClass('last');
        const groups = SetDesign.groupByRow($navItems);
        $.each(groups, (index, $row) => {
            $row.last().addClass('last');
        });
    });
});
